'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ACTION_OPERATION = exports.ACTION_OPERATION = '__$$__WEB_WORKER_PROXY__ACTION_OPERATION';
var ACTION_DISPOSE = exports.ACTION_DISPOSE = '__$$__WEB_WORKER_PROXY__ACTION_DISPOSE';

var RESULT_SUCCESS = exports.RESULT_SUCCESS = '__$$__WEB_WORKER_PROXY__RESULT_SUCCESS';
var RESULT_ERROR = exports.RESULT_ERROR = '__$$__WEB_WORKER_PROXY__RESULT_ERROR';
var RESULT_CALLBACK = exports.RESULT_CALLBACK = '__$$__WEB_WORKER_PROXY__RESULT_CALLBACK';

var TYPE_ERROR = exports.TYPE_ERROR = '__$$__WEB_WORKER_PROXY__TYPE_ERROR';
var TYPE_FUNCTION = exports.TYPE_FUNCTION = '__$$__WEB_WORKER_PROXY__TYPE_FUNCTION';
var TYPE_PERSISTED_FUNCTION = exports.TYPE_PERSISTED_FUNCTION = '__$$__WEB_WORKER_PROXY__TYPE_PERSISTED_FUNCTION';

var MESSAGE_DISPOSED_ERROR = exports.MESSAGE_DISPOSED_ERROR = 'The function has been disposed and is no longer available.';
//# sourceMappingURL=constants.js.map